import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { RegistrationModal } from "./RegistrationModal";

const Ctx = createContext({ open: () => {}, close: () => {}, isOpen: false });

export const RegistrationProvider = ({ children }) => {
  const [isOpen, setOpen] = useState(false);
  const open = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);
  const value = useMemo(() => ({ open, close, isOpen }), [open, close, isOpen]);
  return (
    <Ctx.Provider value={value}>
      {children}
      <RegistrationModal open={isOpen} onClose={close} />
    </Ctx.Provider>
  );
};

export const useRegistration = () => useContext(Ctx);
